import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Switch } from '../../components/ui/switch';
import { Badge } from '../../components/ui/badge';
import { X } from 'lucide-react';

export const ToggleRow = ({ id, label, desc, checked, onChange }) => (
  <div className="flex items-center justify-between py-2.5 border-b last:border-0 border-slate-100 dark:border-slate-800">
    <div>
      <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{label}</p>
      {desc && <p className="text-xs text-slate-500 dark:text-slate-400">{desc}</p>}
    </div>
    <Switch data-testid={`expiry-${id}-switch`} checked={!!checked} onCheckedChange={onChange} />
  </div>
);

export const ChipInput = ({ testId, items, onAdd, onRemove, placeholder, type = 'text' }) => {
  const [val, setVal] = useState('');
  const add = () => { if (val.trim()) { onAdd(val.trim()); setVal(''); } };
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Input data-testid={`${testId}-input`} type={type} value={val} placeholder={placeholder}
          onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), add())} />
        <Button data-testid={`${testId}-add-btn`} type="button" variant="outline" onClick={add}>Ekle</Button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {items.map((it) => (
          <Badge key={it} variant="secondary" className="gap-1 pr-1" data-testid={`${testId}-chip-${it}`}>
            {it}
            <button type="button" onClick={() => onRemove(it)} className="hover:text-red-600"><X className="h-3 w-3" /></button>
          </Badge>
        ))}
      </div>
    </div>
  );
};
